import { useMutation } from '@tanstack/react-query'

import { useNodeApi } from '../api-provider'
import { DatasetType, TaskDefinitionType } from '../lakehouse/types'

export const useAddTaskDefinition = () => {
  const nodeApi = useNodeApi()
  const { urqlClient } = nodeApi

  return useMutation({
    mutationFn: async ({
      name,
      sources,
      destination,
      type,
      typeId,
    }: {
      name: string
      sources: {
        type: DatasetType
        identifier: string
        connectionId: string
      }[]
      destination: {
        type: DatasetType
        identifier: string
        connectionId: string
      }
      type: TaskDefinitionType
      typeId: string
    }) => {
      if (!urqlClient) {
        throw new Error('Node API client is not available')
      }
      const result = await urqlClient
        .mutation(
          /* GraphQL */ `
            mutation AddTaskDefinition(
              $name: String!
              $sources: [Vendia__definitions_Vendia_Dataset_Input_]
              $destination: Vendia__definitions_Vendia_Dataset_Input_
              $type: Vendia_TaskDefinition_typeEnum!
              $typeId: String!
            ) {
              addVendia_TaskDefinition(
                input: { name: $name, sources: $sources, destination: $destination, type: $type, typeId: $typeId }
                syncMode: NODE_LEDGERED
              ) {
                result {
                  _id
                }
              }
            }
          `,
          { name, sources, destination, type, typeId },
        )
        .toPromise()

      if (result.error) {
        throw new Error(result.error.message)
      }

      return result.data?.addVendia_TaskDefinition.result
    },
    onError: (error) => {
      console.error('Error adding task definition:', error)
    },
  })
}
